import fetch from "auth/FetchInterceptor";
import { ApiConstant } from "constants/ApiConstant";
import Utils from "utils";

const PhotographerService = {};

PhotographerService.accessStudentProfile = function ( params) {
  return fetch({
    url: ApiConstant.ACCESS_STUDENT_PROFILE,
    method: "GET",
    params: Utils.filterHeaderParams(params),

  });
};
export default PhotographerService;
